import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Requirements from './requirements/container/RequirementsTagging';

function SettingsContainer({ match, pathName }) {
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid mb-4">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/occupational-and-health/settings/requirements"
                  className={`nav-link btn-settings-tab py-3 px-5 font-weight-bold h2 ${pathName.indexOf('/health-certificate/settings/requirements') > -1 ? 'selected' : ''
                    }`}
                >
                  Requirements
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => (
              <Redirect to={`${match.path}/requirements`} />
            )}
          />
          <Route path={`${match.path}/requirements`} component={Requirements} />
        </Switch>
      </div>
    </React.Fragment>
  );
}

SettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SettingsContainer);
